<template>
  <div class="account_container">
    <div v-if="!isLoading" class="main-content">
          <ul v-if="favoritesList.length" class="favorites-list" v-loading="isLoading">
            <li class="favorite-card" v-for="(item, index) in favoritesList" v-bind:key="index" v-if="!item.IsStopSale">
              <productCard v-if='$i18n.locale=="en"'
                favoritesPage="true"
                v-bind:img="item.ThumbnailLarge"
                v-bind:link="item.link"
                v-bind:brand="item.Brand"
                v-bind:name="item.Name"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
              ></productCard>
              <productCard v-if='$i18n.locale=="ch"'
                favoritesPage="true"
                v-bind:img="item.ThumbnailLarge"
                v-bind:link="item.link"
                v-bind:brand="item.Brand"
                v-bind:name="item.Description"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
              ></productCard>
            </li>
          </ul>
          <div v-else class="continue-shopping">
            <p>{{ $t('you_havent_favorited')}}</p>
            <button @click="continueShopping">{{ $t('continueShopping') }}</button>
          </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import productCard from '../productCard';
export default {
  name: "favorites",
  components: {
    productCard
  },
  data(){
    return{
      favoritesList: [],
      isLoading: false,
      favoritesPage: true,
      inCart: null
    }
  },
  methods:{
    ...mapActions('products', ['getFavorites']),
    loadFavorites() {
      this.isLoading = true;
      this.getFavorites()
      .then(res => {
        this.isLoading = false;
        this.favoritesList = res.data;
      }, (err) => {
        this.isLoading = false;
      })
    },
    continueShopping() {
      this.$router.push('/collections');
    },
  },
  mounted() {
    this.loadFavorites();
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    favoriteSuccess: state => state.products.favoriteSuccess,
  }),
  watch: {
    favoriteSuccess: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadFavorites();
      }
    },
  }
}
</script>
<style scoped lang="less">
@import "../../assets/css/profileorder.less";
@import "../../assets/css/favorites.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/favorites.vue